import { render, staticRenderFns } from "./ActiveOrdersOverview.vue?vue&type=template&id=52edab3d&scoped=true&"
import script from "./ActiveOrdersOverview.vue?vue&type=script&lang=js&"
export * from "./ActiveOrdersOverview.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOrdersOverview.vue?vue&type=style&index=0&id=52edab3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52edab3d",
  null
  
)

export default component.exports